module.exports = __webpack_public_path__ + "2466739bbb16e928a55291bd8e2c7eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-cheers.png
// module id = 2076
// module chunks = 4